module.exports = __webpack_public_path__ + "img/purple-penguin.204ba4ab.svg";